import React from 'react';
import {connect} from 'react-redux';
import {modal} from 'react-redux-modal';
import LoginForm from '../../Forms/Login';
import SocialLogin from '../../SocialLogin';
import SignUpModal from '../SignUp';

import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class LoginComponent extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.signUp = this.signUp.bind(this);
    this.toolTip = this.toolTip.bind(this);
    this.removeModal = this.removeModal.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.removeModal();
  }

  removeModal() {
    const { removeModal, removeModalCallback } = this.props;
    removeModal();
    if (removeModalCallback) {
      removeModalCallback();
    }
  }

  signUp(e) {
    e.preventDefault();
    this.props.removeModal();
    modal.add(SignUpModal, { title: '', size: 'medium', hideTitleBar: true });
  }

  componentDidMount() {
    modalViewGA('login');
  }

  toolTip(e) {
    e.preventDefault();
  }

  render() {
    return (
      <div>
        <div className="modals-popup login-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Login using social or email address</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={this.closeModal}></a>
            </div>
          </div>

          <div className="info d-flex">
            <div className="social-box">
              <SocialLogin removeModal={this.removeModal} />
            </div>
            <div className="login-form col">
              <LoginForm removeModal={this.removeModal} />
            </div>

          </div>
          <div className="modal-footer">
            <span className="other-action">
              <a href="#" className="u-textSize-18" onClick={this.signUp}><span>Not a member? Click to join the explore community.</span><span
                className="arw"></span></a>
            </span>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {};
}

export default connect(mapStateToProps)(LoginComponent);
